import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import { FileCoverUrlProcessor, IMedia } from '../../lib/MediasLib';
import MediasManager from '../../modules/media/MediasManager';
import { MediaListManager } from '../../modules/media/useMediaListManager';
import { ShowroomViewMode } from '../../services/modules/brand-showroom/brand-showroom.types';
import { ShowroomTestIds } from '../../utils/testIds/Showroom.testIds';
import EmphasisMediasCarousel from './EmphasisMediasCarousel';
import Section, { SectionProps } from './Section';

export type EmphasisMediasSectionProps = {
  title?: string;
  mimeTypes?: string;
  medias: IMedia[];
  sectionProps: Partial<SectionProps>;
  mediaListManager: MediaListManager;
  viewMode: ShowroomViewMode;
  processFileCover?: FileCoverUrlProcessor;
  addButtonLabel: string;
  mobileAddButtonLabel: string;
};

const EmphasisMediasSection = ({
  title,
  mimeTypes,
  sectionProps,
  medias,
  mediaListManager,
  viewMode,
  addButtonLabel,
  mobileAddButtonLabel,
  processFileCover,
}: EmphasisMediasSectionProps) => {
  return (
    <Section {...sectionProps}>
      <Box
        sx={{
          pb: { xs: 3, sm: 2 },
        }}
      >
        {title && (
          <Typography
            variant="h5"
            color="text.primary"
            testId={ShowroomTestIds.FEATURED_PRODUCTS_DETAILS}
          >
            {title}
          </Typography>
        )}
      </Box>
      {viewMode === 'VISUALIZATION' ? (
        <EmphasisMediasCarousel medias={medias} />
      ) : (
        <MediasManager
          {...mediaListManager}
          label={addButtonLabel}
          mobileLabel={mobileAddButtonLabel}
          maxSize={12}
          processFileCover={processFileCover}
          mimeTypes={mimeTypes}
        />
      )}
    </Section>
  );
};

export default EmphasisMediasSection;
